import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';

import {
    updateFilter,
    availableFromSelector,
    includeRentedSelector
} from '../../reducers/filters';
import {
    FiltersCheckBox,
    RadioButtonGroup,
    SometimesInlineRadioWrapper
} from './Filters.styles';

export const SelectAvailability = () => {
    const reduxDispatch = useDispatch();

    const {
        selectedValue: availableFromSelectedValue,
        options: availableFromOptions
    } = useSelector(availableFromSelector);

    const {
        label: includeRentedLabel,
        selectedValue: includeRentedSelectedValue
    } = useSelector(includeRentedSelector);

    const onAvailableFromChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('availableFrom', evt.currentTarget.value));
    };

    const onIncludeRentedChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('includeRented', evt.currentTarget.checked));
    };

    return (
        <>
            <RadioButtonGroup>
                {availableFromOptions?.map((option) => (
                    <SometimesInlineRadioWrapper key={option.value}>
                        <Radio
                            label={option.label}
                            value={option.value}
                            id={option.value || 'available-anytime'}
                            onChange={onAvailableFromChange}
                            checked={
                                option.value === availableFromSelectedValue
                            }
                        />
                    </SometimesInlineRadioWrapper>
                ))}
            </RadioButtonGroup>

            <FiltersCheckBox
                label={includeRentedLabel}
                id="underOffer"
                data-testid="filters-modal_let-agreed"
                checked={includeRentedSelectedValue}
                onChange={onIncludeRentedChange}
            />
        </>
    );
};
